import './messages.scss';

export default function UserMessage(){
    return(
        <div className='user-message'>
            <p className='px18 white'>wadd</p>
        </div>
    );
}